module.exports = Object.freeze([
	{ label: 'Unverified', key: 'unverified', order: 0 },
	{ label: 'Verified', key: 'verified', order: 1 },
	{ label: 'Active', key: 'active', order: 2 },
	{ label: 'Sick', key: 'sick', order: 3 },
	{ label: 'On Leave', key: 'leave', order: 4 },
	{ label: 'Inactive', key: 'inactive', order: 5 },
	{ label: 'Unsuitable', key: 'unsuitable', order: 6 },
	{ label: 'Active - Incomplete', key: 'active-incomplete', order: 7 },
	{ label: 'Available', key: 'available', order: 8 },
]);


//////////////////
// WEBPACK FOOTER
// ../server/constants/statuses/candidate-statuses.js
// module id = 205
// module chunks = 0